import { ArrowUpRight } from "lucide-react";
import { activities } from "@/lib/data";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogDescription,
} from "@/components/ui/dialog";

export const Activities = () => (
  <section id="activites" className="py-24 md:py-32 relative" data-testid="activities-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="mb-14 max-w-3xl">
        <span className="font-sans text-sm font-bold tracking-[0.25em] uppercase text-[#FF6B6B]">
          Nos activités
        </span>
        <h2 className="mt-3 font-display text-5xl md:text-7xl leading-none uppercase">
          Ce qu'on fait <br />
          <span className="italic font-display">ensemble.</span>
        </h2>
        <p className="mt-5 text-lg text-[#3a3a3a] max-w-xl">
          Aucune expérience requise. Les erreurs font partie du jeu. Trouve ton truc, ose, ris de toi.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
        {activities.filter((a) => !a._hidden).map((a, idx) => (
          <article
            key={a.id}
            className="relative border-2 border-black rounded-3xl overflow-hidden shadow-brutal hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-brutal-sm transition-all flex flex-col"
            style={{ backgroundColor: a.color }}
            data-testid={`activity-card-${a.id}`}
          >
            {a.topSticker && (
              <span className="absolute top-3 left-3 z-10 max-w-[calc(100%-1.5rem)] bg-[#FF6B6B] text-white font-sans text-xs md:text-sm font-bold tracking-wider uppercase px-3 py-1.5 rounded-full border-2 border-black shadow-brutal-sm leading-tight text-center whitespace-normal animate-pulse-slow">
                {a.topSticker}
              </span>
            )}
            <div
              className="relative aspect-[5/3] border-b-2 border-black overflow-hidden"
              style={{ backgroundColor: a.imageBg || "rgba(0,0,0,0.05)" }}
            >
              <img
                src={a.image}
                alt={a.title}
                className={`w-full h-full ${a.imageFit === "contain" ? "object-contain" : "object-cover"}`}
                style={{ objectPosition: a.imagePosition || "center" }}
                loading="lazy"
              />
              {a.credit && (
                <span className="absolute bottom-2 right-2 bg-black/65 text-white text-[10px] font-sans font-medium tracking-wide px-2 py-0.5 rounded">
                  {a.credit}
                </span>
              )}
            </div>
            <div className="p-6 flex-1 flex flex-col">
              <h3 className="font-display text-3xl md:text-4xl uppercase leading-none">{a.title}</h3>
              <p className="mt-3 text-sm md:text-base text-[#1a1a1a]">{a.subtitle}</p>
              {a.details && (
                <Dialog>
                  <DialogTrigger asChild>
                    <button
                      data-testid={`activity-details-${a.id}`}
                      className="mt-3 group inline-flex items-center gap-1.5 self-start bg-white border border-black/70 px-3 py-1 font-sans text-xs font-bold uppercase tracking-wider hover:bg-[#FFF3B0] hover:-translate-y-0.5 transition-all"
                      style={{
                        borderRadius: "55% 45% 50% 50% / 55% 50% 50% 45%",
                      }}
                    >
                      Découvrir
                      <span className="inline-block transition-transform group-hover:translate-x-0.5">→</span>
                    </button>
                  </DialogTrigger>
                  <DialogContent className="bg-white border-2 border-black rounded-3xl max-w-lg">
                    <DialogHeader>
                      <DialogTitle className="font-display text-3xl uppercase leading-tight pr-6">
                        {a.details.heading}
                      </DialogTitle>
                      <DialogDescription className="pt-4 text-base text-[#1a1a1a] leading-relaxed font-sans">
                        {a.details.body}
                      </DialogDescription>
                    </DialogHeader>
                  </DialogContent>
                </Dialog>
              )}
              {a.dates && (
                <p className="mt-2 font-sans text-xs font-bold tracking-widest uppercase text-[#3a3a3a]">
                  {a.dates}
                </p>
              )}
              {a.earlyBird && (
                <div className="mt-3 inline-flex items-center gap-2 bg-black text-white font-sans text-[11px] font-bold tracking-widest uppercase px-3 py-1.5 rounded-full self-start">
                  🔥 {a.earlyBird}
                </div>
              )}
              <a
                href={a.cta.href}
                target={a.cta.type === "helloasso" ? "_blank" : undefined}
                rel="noopener noreferrer"
                data-testid={`activity-cta-${a.id}`}
                className="mt-6 inline-flex items-center justify-between gap-2 bg-black text-white rounded-full px-5 py-3 font-sans font-bold text-sm hover:opacity-90 group"
              >
                {a.cta.label}
                <ArrowUpRight size={18} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
              </a>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);
